import { FunctionComponent, memo, useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Copyright } from '../../Copyright';
import { Modal } from '../../Modal';
import { ImageGalleryItem } from '../ImageGallery';

import classNames from 'classnames';
import classes from './ImageSingle.module.scss';

interface ImageSingleProps {
  item: ImageGalleryItem;
  captionClass?: string;
  fullSize?: boolean;
  maxHeight?: string;
  modalPreviewOnClick?: boolean;
  onLogClickOpenArticle?: () => void;
}

const AVERAGE_COLOR_PLACEHOLDER = 'rgb(228, 228, 235)';

export const ImageSingle: FunctionComponent<ImageSingleProps> = memo(
  ({ item, captionClass, fullSize, maxHeight, modalPreviewOnClick, onLogClickOpenArticle }) => {
    const { t } = useTranslation();

    const { image, caption } = item;
    const { url, averageColor, rightholder } = image;

    const [isModalPreviewOpened, setIsModalPreviewOpened] = useState(false);

    const modalPreviewBody = useMemo(
      () => <img className={classes['image__modal-preview']} src={url} alt={''} />,
      [url]
    );

    const modalPreviewOnClickHandler = useCallback(() => {
      onLogClickOpenArticle?.();
      setIsModalPreviewOpened(true);
    }, [onLogClickOpenArticle]);

    const Tag = modalPreviewOnClick ? 'button' : 'div';

    return (
      <>
        <Tag
          className={classNames(classes['image__wrapper'], {
            [classes['image__wrapper--full-size']]: fullSize,
          })}
          style={{ backgroundColor: averageColor ?? AVERAGE_COLOR_PLACEHOLDER }}
          onClick={() => modalPreviewOnClick && modalPreviewOnClickHandler()}
          {...(modalPreviewOnClick && { type: 'button', 'aria-label': t('common.preview') })}
        >
          <img
            className={classNames(classes['image__preview'], {
              [classes['image__preview--full-size']]: fullSize,
            })}
            style={{ maxHeight }}
            src={url}
            alt={''}
          />
          {rightholder && <Copyright copyright={rightholder} />}
        </Tag>
        {caption && (
          <div
            className={classNames(classes['image__caption'], captionClass)}
            dangerouslySetInnerHTML={{ __html: caption.replace(/href/g, "target='_blank' href") }}
          ></div>
        )}

        {modalPreviewOnClick && (
          <Modal
            isOpen={isModalPreviewOpened}
            body={modalPreviewBody}
            onClose={() => setIsModalPreviewOpened(false)}
            previewSrc={url}
            root={'modal-preview-root'}
            ariaLabel={t('common.preview')}
            previewMode
          />
        )}
      </>
    );
  }
);
